import MuiInfoOutlined from '@mui/icons-material/InfoOutlined';
import { SvgIconProps } from '@mui/material/SvgIcon';

export type InfoOutlinedProps = SvgIconProps;

export const InfoOutlined = (props: InfoOutlinedProps) => {
  return <MuiInfoOutlined {...props} />;
};
